
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileTabBar } from "./MobileTabBar";

export const MobileNavigation = () => {
  // Use the hook safely inside a functional component
  const isMobile = useIsMobile();

  // Only return the MobileTabBar on mobile views
  if (isMobile) {
    return <MobileTabBar />;
  }

  // Don't render anything on non-mobile views as we use different navigation
  return null;
};
